import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=20075002&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20075002')) {
      api.createRecord('20075002', component.options)
    } else {
      api.reload('20075002', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=20075002&", function () {
      api.rerender('20075002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28MIQQHqnYCA0/JS/offershelp.vue"
export default component.exports